/**
 * Copyright IBM Corp. 2022, 2026
 */

'use client'

import Image from 'next/image'
import { Text } from '@hashicorp/mds-react/components'
import BlogPostSocialShare from '../social-share'
import sendPosthogEvent from '@web/utils/send-posthog-event'
import s from './metadata.module.css'

export interface IMetadata {
	subtitle?: string
	authors: {
		name: string
		photo?: {
			src: string
			alt: string
			width: number
			height: number
		}
		slug: string
	}[]
	date: string
}

const socialText = 'Share article'

export const Metadata = ({ date, authors, subtitle }: IMetadata) => {
	return (
		<>
			<Text.Label tag="p" color="primary" weight="semibold" className={s.date}>
				{date}
			</Text.Label>
			<div className={s.authors}>
				<ul className={s.authorImages}>
					{authors.map((author, index) => {
						return (
							<li key={index} className={s.authorImage}>
								{author.photo ? (
									<Image
										src={author.photo.src}
										width={author.photo.width}
										height={author.photo.height}
										alt={author.photo.alt}
									/>
								) : (
									<Image
										src={
											'https://www.datocms-assets.com/2885/1753314445-frame.png'
										}
										width={200}
										height={200}
										alt={'Avatar image of blog post author'}
									/>
								)}
							</li>
						)
					})}
				</ul>
				<ul className={s.authorNames}>
					{authors.map((author, index) => {
						const href = `/blog/authors/${author.slug}`
						return (
							<li key={index} className={s.author}>
								<a
									href={href}
									onClick={() => {
										sendPosthogEvent('Blog Author Clicked', {
											href,
										})
									}}
								>
									<Text.Body color="primary" weight="medium" size="200">
										{author.name}
									</Text.Body>
								</a>
							</li>
						)
					})}
				</ul>
			</div>
			<div className={s.social}>
				<Text.Label
					tag="p"
					color="faint"
					weight="semibold"
					className={s.shareText}
				>
					{socialText}
				</Text.Label>
				<BlogPostSocialShare summary={subtitle ? subtitle : ''} />
			</div>
		</>
	)
}
